import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Stack,
} from "@mui/material";

import GavelIcon from "@mui/icons-material/Gavel"; // ⚖️ derecho
import BusinessIcon from "@mui/icons-material/Business"; // 🏢 inmobiliaria
import LockIcon from "@mui/icons-material/Lock"; // 🔐 acceso

import api from "../services/api.service";

/* ================= JWT ================= */
const parseJwt = (token: string) => {
  try {
    const base64Payload = token.split(".")[1];
    const payload = atob(base64Payload);
    return JSON.parse(payload);
  } catch {
    return null;
  }
};

/* ================= COMPONENT ================= */
const LoginPage = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      setError("Correo y contraseña son obligatorios");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const resp = await api.post("/auth/login", { email, password });
      const { token, usuario } = resp.data;

      localStorage.setItem("token", token);

      const decoded = parseJwt(token);

      if (decoded?.rol) localStorage.setItem("rol", decoded.rol);
      if (decoded?.usuarioId) localStorage.setItem("usuarioId", decoded.usuarioId);
      if (decoded?.estudioId) localStorage.setItem("estudioId", decoded.estudioId);

      if (usuario?.debeCambiarPassword) {
        navigate("/cambiar-password-obligatorio", { replace: true });
      } else {
        navigate("/");
      }
    } catch (err: any) {
      setError(err.response?.data?.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: "linear-gradient(135deg, #0f172a, #1e293b)",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 5,
          width: 420,
          borderRadius: 3,
          backdropFilter: "blur(8px)",
          background: "rgba(255,255,255,0.97)",
        }}
      >
        <Stack spacing={3}>

          {/* 🔥 HEADER NUEVO */}
          <Box textAlign="center">
            <Box display="flex" justifyContent="center" gap={1} mb={1}>
              <GavelIcon sx={{ color: "#0f172a" }} />
            </Box>

            <Typography variant="h5" fontWeight={700}>
              Acceso al Sistema
            </Typography>

          </Box>

          {/* ERROR */}
          {error && (
            <Typography color="error" textAlign="center">
              {error}
            </Typography>
          )}

          {/* INPUT EMAIL */}
          <TextField
            label="Correo electrónico"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />

          {/* INPUT PASSWORD */}
          <TextField
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />

          {/* BUTTON */}
          <Button
            variant="contained"
            startIcon={<LockIcon />} // 🔥 icono en botón
            onClick={handleLogin}
            disabled={loading}
            fullWidth
            sx={{
              py: 1.5,
              fontWeight: 600,
              background: "#0f172a",
              "&:hover": {
                background: "#020617",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Ingresar"
            )}
          </Button>

        </Stack>
      </Paper>
    </Box>
  );
};

export default LoginPage;